/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './admin.tpl.html';
import './batch/batch.js';
import './chatter/api.tpl.html';
import './expiredLicense/expiredlicense.tpl.html';
import './log/log.tpl.html';
import './start/BatchStart.js';

angular
  .module('mobile.admin', ['mobile.admin.batch', 'sbsf.constants'])
  // This defines the main abstract main view that is shared across all
  // subviews.
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      $stateProvider
        .state(VIEW_STATES.MOBILE_EXPIRED, {
          url: '/expiredLicenseMobile',
          views: {
            content: {
              templateUrl: 'mobile/admin/expiredLicense/expiredlicense.tpl.html'
            }
          }
        })
        .state(VIEW_STATES.MOBILE, {
          abstract: true,
          resolve: {
            paymentInfo: [
              'billingUtils',
              function (billingUtils) {
                return billingUtils.getPaymentInfo();
              }
            ]
          },
          views: {
            content: {
              templateUrl: 'mobile/admin/admin.tpl.html',
              controller: 'MobileAdminCtrl'
            }
          }
        })
        // The views that are rendered in the admin view.
        .state(VIEW_STATES.MOBILE_HOME, {
          url: '/mobile/admin',
          resolve: {
            // Batches to be shown in the admin batch history boinks.
            batchesInfo: [
              'batchUtils',
              'BATCH_LIMITS',
              function (batchUtils, BATCH_LIMITS) {
                return batchUtils.getBatches(BATCH_LIMITS.NUM_BATCHES_ON_DASHBOARD_MOBILE);
              }
            ]
          },
          views: {
            batch: {
              templateUrl: 'mobile/admin/batch/batch.tpl.html',
              controller: 'MobileBatchCtrl'
            },
            log: {
              templateUrl: 'mobile/admin/log/log.tpl.html',
              controller: 'AdminLogCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progressmobile.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The views that are rendered for the start view.
        //TODO: update these for mobile view
        .state(VIEW_STATES.MOBILE_START, {
          url: 'mobile/start',
          views: {
            batch: {
              templateUrl: 'mobile/admin/start/batchStart.tpl.html',
              controller: 'MobileBatchStartCtrl'
            },
            log: {
              templateUrl: 'mobile/admin/start/log.tpl.html',
              controller: 'AdminLogCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progressmobile.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        .state(VIEW_STATES.MOBILE_CHATTER, {
          url: '/mobile/api',
          resolve: {
            apiTitle: [
              '$rootScope',
              '$filter',
              'MOBILE_EVENTS',
              function ($rootScope, $filter, MOBILE_EVENTS) {
                var apiTitle = $filter('i18n')('API_USAGE');
                $rootScope.$emit(MOBILE_EVENTS.HEADER_CHANGE, {
                  title: apiTitle
                });
                return apiTitle;
              }
            ]
          },
          views: {
            content: {
              templateUrl: 'mobile/admin/chatter/api.tpl.html',
              controller: 'AdminAPICtrl'
            }
          }
        });
    }
  ])
  .controller('MobileAdminCtrl', [
    '$scope',
    '$rootScope',
    '$filter',
    '$state',
    'progressFactory',
    'PROGRESS_ACTIONS',
    'VIEW_STATES',
    'billingUtils',
    'paymentInfo',
    function (
      $scope,
      $rootScope,
      $filter,
      $state,
      progressFactory,
      PROGRESS_ACTIONS,
      VIEW_STATES,
      billingUtils,
      paymentInfo
    ) {
      // Make a local reference to the progress ACTIONS constant.
      $scope.ACTIONS = PROGRESS_ACTIONS;

      /**
       * Utility function used to update billing related scope values.
       *
       * @param {Object} paymentInfo - The paymentInfo object returned from the server.
       */
      $scope.updateBillingInfo = function (paymentInfo) {
        $scope.inTrial = billingUtils.inTrial();
        $scope.isExpiredOrg = billingUtils.isAccessStopped();
        $rootScope.renewSupportContact = $filter('i18n')('RENEW_SUPPORT_CONTACT_MOBILE');
        if ($scope.inTrial) {
          if (moment().isAfter(moment(paymentInfo.expires))) {
            //TODO launch mask that trial is over
          }
        } else if ($scope.isExpiredOrg) {
          $state.go(VIEW_STATES.MOBILE_EXPIRED);
        }
      };

      $scope.updateBillingInfo(paymentInfo);

      /**
       * Redirect the view to the log view.
       */
      $scope.goToLogs = function () {
        return $state.go(VIEW_STATES.MOBILE_ACTIVITY_LOGS);
      };
    }
  ]);
